module.exports = __webpack_public_path__ + "img/CheckIcon.b28f54be.svg";